import * as yup from 'yup'

const schema = yup.object().shape({
  scheduledDate: yup.mixed().nullable(),
  scheduledTime: yup.mixed().nullable(),
})

export default schema
